<template>
  <div>
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />

    <div class="ma-4" v-show="!showSkeleton">
      <div class="text-h4">Atualizar URA - {{ description }}</div>
    </div>
    <div v-if="canRender">
      <CadastroUra edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import urasStore from '../_store'

import CadastroUra from './CadastroUra'

export default {
  name: 'AtualizarUra',
  props: {
    _id: String,
  },
  components: { CadastroUra, SkeletonLoaderTitleUpdate },
  data: () => ({
    description: '',
    showSkeleton: false,
    canRender: false,
  }),
  computed: {
    ...mapGetters('atualizarURAModulePABXStore', ['getUraSelecionada']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarURAModulePABXStore', urasStore)
    await this.selecionarUra(this._id)
    this.description = this.getUraSelecionada.description

    this.showSkeleton = false
    this.canRender = true
  },
  methods: {
    ...mapActions('atualizarURAModulePABXStore', ['selecionarUra']),
  },
}
</script>
